<div class="login-body">
  <div class="login-image" [ngStyle]="background" (click)="calculateBackground()"></div>
  <div class="card login-panel container-fluid">
    <div class="login-panel-content">
      <form #f="ngForm">
        <div class="login-spiner" [style.z-index]="show_spin" aria-hidden="true">
          <div class="nb-spinner" role="status">
            <span class="sr-only">...</span>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <img src="assets/img/icon-login.svg" />
          </div>
          <div class="col-9 text-right">
            <h2 class="welcome-text">{{ 'LoginView.welcome' | translate }}</h2>
            <span class="guest-sign-in">{{ 'LoginView.description' | translate }}</span>
          </div>
          <div class="col-12 p-2">
            <label class="login-label">{{ 'General.user' | translate }}</label>
            <div class="login-input">
              <input pInput id="userName" name="userName" type="text" [(ngModel)]="name" class="w-100"
                [ngModelOptions]="{ standalone: true }" autofocus autocapitalize="off" tabindex="1" />
            </div>
          </div>
          <div class="col-12 p-2">
            <label class="login-label">{{ 'LoginView.pass' | translate }}</label>
            <div class="login-input">
              <input pInput id="pass" name="pass" [(ngModel)]="pass" autocomplete="off" type="password" class="w-100"
                [ngModelOptions]="{ standalone: true }" tabindex="2" />
            </div>
          </div>
          <div class="col-12 p-2" *ngIf="modoMesaEnabled">
            <p-checkbox [(ngModel)]="modoAcceso" label="{{ 'LoginView.modoMesa' | translate }}" binary="true"
              [ngModelOptions]="{ standalone: true }" tabindex="3"></p-checkbox>
          </div>
          <!-- <div class="ui-g-12 ui-md-6 button-pane">
            <button
              type="submit"
              class="p-button ui-widget ui-state-default ui-corner-all p-button-text-only"
              aria-disabled="false"
            >
              <span class="p-button-text ui-c">{{
                'LoginView.access' | translate
              }}</span>
            </button>
          </div> -->
          <!-- <div class="ui-g-12" *ngIf="login2fa > 0">
            <label class="login-label">{{ 'LoginView.verificationCode' | translate }}</label>
            <div class="login-input">
              <input pInput id="code" name="code" type="text" [(ngModel)]="code" [ngModelOptions]="{ standalone: true }"
                autofocus autocapitalize="off" tabindex="4" />
            </div>
          </div> -->
          <div class="col-12 p-2 text-center">
            <button pButton appDebounceClick tabindex="5" (debounceClick)="onSubmit()"
              class="btn btn-primary  btn-lg btn-block" id="btn"> {{
              'LoginView.access' | translate }} </button>
            <a *ngIf="resetPassword" tabindex="6" href="#forgotten-password">{{
              'LoginView.forgotPassword' | translate }}</a>
          </div>
          <div class="col-12 p-2 text-center" *ngIf="errorMsg">
            <span class="text-danger">
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ errorMsg }}</span>
          </div>
          <!-- <div class="ui-g-12 ui-md-6 link-pane">
            <a href="#">Forget Password?</a>
          </div> -->
        </div>
      </form>
    </div>
  </div>
</div>